import api from './axiosConfig';
const systemSettingsAPI = {
  get:    ()       => api.get('/trucking/system-settings'),
  update: (data)   => api.put('/trucking/system-settings', data),
  getPaymentGLMapping:    ()       => api.get('/trucking/system-settings/payment-gl-mapping'),
  updatePaymentGLMapping: (data)   => api.patch('/trucking/system-settings/payment-gl-mapping', { paymentGLMapping: data }),
  getWaybillGLMapping:    ()       => api.get('/trucking/system-settings/waybill-gl-mapping'),
  updateWaybillGLMapping: (data)   => api.patch('/trucking/system-settings/waybill-gl-mapping', { waybillGLMapping: data }),
};
export default systemSettingsAPI;
